import React from "react";

const VideoManual = props => (
  <svg viewBox="0 0 23 15" fill="none" {...props}>
    <path
      d="M21.21 1.25a1.26 1.26 0 00-.702.234L16.25 4.22V1.875C16.25.859 15.312 0 14.219 0H1.992C.898 0 0 .86 0 1.875v11.29C0 14.18.898 15 1.992 15H14.22c1.094 0 2.031-.82 2.031-1.836V10.82l4.258 2.735c.234.156.469.195.703.195.664 0 1.25-.508 1.25-1.21V2.5c.039-.742-.586-1.25-1.25-1.25zM15 13.164c0 .313-.39.586-.781.586H1.992c-.39 0-.742-.273-.742-.586V1.875c0-.313.352-.625.742-.625H14.22c.39 0 .781.313.781.625v11.29zm6.25-.625l-.078-.039-4.922-3.164V5.703l5-3.203v10.04z"
      fill="currentColor"
    />
  </svg>
);

export default VideoManual;
